import { createAction, props } from '@ngrx/store';

export const setHttpHeader = createAction(
  '[Core] Set Http Header',
  props<{ payload: string }>()
);

export type HttpHeaderActions = typeof setHttpHeader;
